exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-activity-template-details{margin:0 auto}.c-activity-template-details_buttons{width:500px}.c-activity-template-details_buttons>.a-button-primary{margin-right:20px}.c-activity-template-details_buttons>.a-button-primary:last-child{margin-right:0}", ""]);

// exports
